import { QueueEntityModel } from "src/store/models/entity/queue/entity";
import { QueueHelperModel } from "src/store/models/entity/queue/helper";

export const encooQueueModels = {
  entity: QueueEntityModel,
  helper: QueueHelperModel,
};
